import uuid from "uuid/v4";

export function convertToDynamo(application) {
  // TODO maritalStatus is spelled martialStatus in Lambda
  const {
    termApplying,
    edGoalTransfer: transfer,
    edGoalDegree: degree,
    edGoalCertificate: certificate,
    hsDiploma: highSchoolDiploma,
    hsGed: ged,
    hsForeignDiploma: foreignDiploma,
    degrees,
    sjdcEops: eopsParticipation,
    otherEops: eopsParticipationOther,
    sjdcDsps: disabilitySupport,
    fosterYouth,
    veteran,
    headOfHousehold,
    cashAid: receivingCashAid,
    calworks: receivingCalWorks,
    dependents: dependentChildren,
    colleges,
    collegeMajor,
    hsGpa: highSchoolGPA,
    hsName: highSchoolName,
    collegeUnits: unitsEarned,
    motherLanguage: motherFirstLanguage,
    motherEdLevel: motherEducation,
    fatherLanguage: fatherFirstLanguage,
    fatherEdLevel: fatherEducation,
    maritalStatus: martialStatus,
    deltaId,
    email: emailId,
    ab540
  } = application;

  // Add required elements
  const newApplication = {
    termApplying,
    transfer,
    degree,
    certificate,
    highSchoolDiploma,
    ged,
    foreignDiploma,
    graduate: (degrees.length > 0),
    degreeReceived: (degrees.length > 0),
    eopsParticipation,
    eopsParticipationOther,
    disabilitySupport,
    fosterYouth,
    veteran,
    headOfHousehold,
    receivingCashAid,
    receivingCalWorks,
    dependentChildren,
    collegeMajor,
    highSchoolGPA,
    highSchoolName,
    unitsEarned,
    motherFirstLanguage,
    motherEducation,
    fatherFirstLanguage,
    fatherEducation,
    martialStatus,
    deltaId,
    emailId,
    ab540
  };

  // Sets can't be empty or contain empty elements
  const filteredColleges = colleges.filter(college => college.name.trim().length > 0);
  if(filteredColleges.length > 0)
    newApplication.colleges = filteredColleges.map(college => college.name);
  const filteredDegrees = degrees.filter(degree => degree.name.trim().length > 0);
  if(filteredDegrees.length > 0)
    newApplication.degrees = filteredDegrees.map(degree => degree.name);

  return newApplication;
}

export function convertFromDynamo(application) {
  const {
    termApplying,
    transfer: edGoalTransfer,
    degree: edGoalDegree,
    certificate: edGoalCertificate,
    highSchoolDiploma: hsDiploma,
    ged: hsGed,
    foreignDiploma: hsForeignDiploma,
    degrees,
    eopsParticipation: sjdcEops,
    eopsParticipationOther: otherEops,
    disabilitySupport: sjdcDsps,
    fosterYouth,
    veteran,
    headOfHousehold,
    receivingCashAid: cashAid,
    receivingCalWorks: calworks,
    dependentChildren: dependents,
    colleges,
    collegeMajor,
    highSchoolGPA: hsGpa,
    highSchoolName: hsName,
    unitsEarned: collegeUnits,
    motherFirstLanguage: motherLanguage,
    motherEducation: motherEdLevel,
    fatherFirstLanguage: fatherLanguage,
    fatherEducation: fatherEdLevel,
    martialStatus: maritalStatus,
    deltaId,
    emailId: email,
    ab540
  } = application;

  return {
    termApplying,
    edGoalTransfer,
    edGoalDegree,
    edGoalCertificate,
    hsDiploma,
    hsGed,
    hsForeignDiploma,
    degrees: degrees ? degrees.map(degree => ({ id: uuid(), name: degree })) : [],
    sjdcEops,
    otherEops,
    sjdcDsps,
    fosterYouth,
    veteran,
    headOfHousehold,
    cashAid,
    calworks,
    dependents,
    colleges: colleges ? colleges.map(college => ({ id: uuid(), name: college })) : [],
    collegeMajor,
    hsGpa,
    hsName,
    collegeUnits,
    motherLanguage,
    motherEdLevel,
    fatherLanguage,
    fatherEdLevel,
    maritalStatus,
    deltaId,
    email,
    ab540
  }
}